import type { SVGProps } from 'react';
export const DoubleChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M5.2 5.2a.7.7 0 0 1 1.02 0l4.29 4.3a.7.7 0 0 1 0 1l-4.3 4.3a.71.71 0 0 1-1-1.02L8.99 10 5.21 6.22a.7.7 0 0 1 0-1.01m4.3 0a.7.7 0 0 1 1 0l4.3 4.3c.27.27.27.73 0 1l-4.3 4.3a.71.71 0 0 1-1-1.02L13.27 10 9.49 6.22a.7.7 0 0 1 0-1.01"
      clipRule="evenodd"
    />
  </svg>
);
